import styled from 'styled-components';

const StyledModalDiv = styled.div`
    overflow-x: hidden;
`;

export default StyledModalDiv;
